var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CenteredContainer',{staticClass:"vertical-spacing"},[_c('SfHeading',{staticClass:"sf-heading--left",attrs:{"level":1,"title":_vm.$t('Logging out!')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }